var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSyncLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "launchpad_cloud_sync-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(62.500000, 45.000000)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-8",
    fill: "#41A7F1",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(57.500000, 50.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.716005,23.5643852 C38.716005,24.6209287 38.716005,25.6774721 38.716005,26.7340155 L38.716005,29.5866827 C38.716005,31.9110782 40.3898572,32.8619672 42.3775566,31.6997695 L48.0268078,28.4244849 C50.0145073,27.2622872 53.2575959,25.360509 55.2452954,24.1983113 L60.8945465,20.9230267 C62.882246,19.760829 62.882246,17.8590509 60.8945465,16.6968531 L55.2452954,13.4215685 C53.2575959,12.2593708 50.0145073,10.3575927 48.0268078,9.19539492 L42.3775566,6.0257647 C40.3898572,4.86356696 38.716005,5.70880168 38.716005,7.92754284 C38.716005,9.4067036 38.716005,11.3084817 38.716005,12.9989512 C19.2574733,13.8441859 3.66972477,30.1149544 3.66972477,49.9779704 C3.66972477,59.6981697 7.4358922,68.5731343 13.5036064,75.2293578 L20.9313255,67.7278996 C16.746695,63.0791086 14.131301,56.8455025 14.131301,49.9779704 C14.131301,35.9259431 25.0113402,24.40962 38.716005,23.5643852 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5565333,25.6880734 L64.994071,33.1895316 C69.2546132,37.8383226 71.917452,44.0719287 71.917452,50.9394608 C71.917452,64.6745251 61.3726102,75.8738852 47.9519025,77.2473916 C47.9519025,76.5078112 47.9519025,75.3456135 47.9519025,74.0777614 L47.9519025,71.3307485 C47.9519025,69.006353 46.2476856,68.055464 44.2239281,69.2176617 L38.4721962,72.4929463 C36.4484387,73.655144 33.1465185,75.5569222 31.122761,76.7191199 L25.3710291,79.8887501 C23.3472716,81.0509479 23.3472716,82.952726 25.3710291,84.1149237 L31.122761,87.3902083 C33.1465185,88.5524061 36.4484387,90.4541842 38.4721962,91.6163819 L44.2239281,94.8916665 C46.2476856,96.0538642 47.9519025,95.2086295 47.9519025,92.9898884 C47.9519025,90.7711472 47.9519025,88.8693691 47.9519025,88.8693691 C47.9519025,88.8693691 47.9519025,88.4467517 47.9519025,87.8128257 C67.3373692,86.4393192 82.5688073,70.4855138 82.5688073,50.9394608 C82.5688073,41.2192615 78.7343194,32.3442969 72.5565333,25.6880734 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSyncLogo);
export default __webpack_public_path__ + "static/media/cloud-sync-logo.34ac8683a84d3e37ecd97eb36788899a.svg";
export { ForwardRef as ReactComponent };